import { useState } from "react";
import { offsetNumber } from "../../utils/config";

const PaginationButtons = ({
  backButtonOnClick,
  nextButtonOnClick,
  page,
  totalCount,
  pageSize = offsetNumber,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const maxPages = Math.max(1, Math.ceil(totalCount / pageSize));

  return (
    <div className="flex justify-center items-center gap-3">
      {/* Previous Page Button */}
      <button
        type="button"
        disabled={isLoading || page <= 1}
        onClick={async () => {
          if (page <= 1) return;
          setIsLoading(true);
          await backButtonOnClick();
          setIsLoading(false);
        }}
        className="p-1.5 rounded-lg border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
        title="Previous page"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M5 12l14 0" />
          <path d="M5 12l6 6" />
          <path d="M5 12l6 -6" />
        </svg>
      </button>

      {/* Page Counter */}
      <div className="flex items-center justify-center min-w-[72px] font-medium text-xs text-gray-700">
        {isLoading ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="animate-spin h-4 w-4 text-blue-600"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
        ) : (
          <span>
            Page <span className="font-semibold text-gray-900">{page}</span> of{" "}
            <span className="font-semibold text-gray-900">{maxPages}</span>
          </span>
        )}
      </div>

      {/* Next Page Button */}
      <button
        type="button"
        disabled={isLoading || page >= maxPages}
        onClick={async () => {
          if (page >= maxPages) return;
          setIsLoading(true);
          await nextButtonOnClick();
          setIsLoading(false);
        }}
        className="p-1.5 rounded-lg border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
        title="Next page"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M5 12l14 0" />
          <path d="M13 18l6 -6" />
          <path d="M13 6l6 6" />
        </svg>
      </button>
    </div>
  );
};

export default PaginationButtons;
